// Acronyms that should always be fully uppercase
const KNOWN_ACRONYMS = new Set([
	'PP',
	'PPES',
	'PPI',
	'SA',
	'SL',
	'SLU',
	'SAU',
	'EPP',
	'EGFP',
	'SAS',
	'SCP',
	'AIE'
]);

// Spanish connectors that stay lowercase when they are not the first word
const CONNECTORS = new Set(['de', 'del', 'la', 'las', 'los', 'el', 'y', 'e', 'en', 'a', 'con']);

const isAcronym = (word: string): boolean => {
	const clean = word.replace(/\./g, '').toUpperCase();
	if (KNOWN_ACRONYMS.has(clean)) return true;
	// Dot-separated single letters: S.A., E.G.F.P., S.a., etc.
	return /^[A-Za-z](\.[A-Za-z])+\.?$/.test(word);
};

const toTitleCase = (str: string): string =>
	str
		.toLowerCase()
		.split(' ')
		.map((word, i) => {
			const match = word.match(/^(.*?)([,;:.]*)$/);
			const core = match?.[1] ?? word;
			const suffix = match?.[2] ?? '';
			if (isAcronym(core)) return core.toUpperCase() + suffix;
			if (i > 0 && CONNECTORS.has(core)) return core + suffix;
			return core.charAt(0).toUpperCase() + core.slice(1) + suffix;
		})
		.join(' ');

export default toTitleCase;
